import { Typography, Icon, IconButton, EmptyCell, type IColumn, Button } from 'shared/ui'
import { type TollFreeProfileNumber } from 'entities/Compliance/model'
import styles from './styles.module.scss'
import { StatusLine } from './StatusLine/StatusLine'

export const getUseCaseColumns = (
  showDetails: (item: TollFreeProfileNumber) => void,
  updateStatusAction: (item: TollFreeProfileNumber) => void,
  learnMoreModalAction: () => void
): IColumn<TollFreeProfileNumber>[] => [
  {
    field: 'phoneNumber',
    name: 'Number',
    width: '145px',
    renderRowCell: (row) => (
      <div className={styles.phoneCellWrapper}>
        <Typography
          variant={'body-md-regular'}
          ariaLabel={'number'}
          color='var(--content-primary-tertiary)'
        >
          {row.formattedNumber}
        </Typography>
        {row.isAircall && <Icon icon='aircall' />}
      </div>
    ),
  },
  {
    field: 'inbox',
    name: 'Inbox',
    width: '190px',
    renderRowCell: (row) => (
      <div className={styles.inboxCellWrapper}>
        <Icon icon='inboxOpen' color='var(--content-primary-tertiary)' />
        <Typography
          variant={'body-md-regular'}
          ariaLabel={'number'}
          ellipsis
          color='var(--content-primary-tertiary)'
          tooltipProps={{
            placement: 'top',
            label: row.numberableName,
          }}
        >
          {row.numberableName ? row.numberableName : <EmptyCell />}
        </Typography>
      </div>
    ),
  },
  {
    field: 'status',
    name: 'Status',
    renderRowCell: (row) => (
      <div className={styles.statusCellWrapper}>
        <StatusLine tollFree={row} />
        <div className={styles.checkConditionIcon}>
          {row.isStatusRejected && (
            <Button text='Update' size={'small'} onClick={() => updateStatusAction(row)} />
          )}
          {row.isStatusBlocked && (
            <Button
              size={'small'}
              text={'Learn more'}
              typeBtn={'outlined'}
              contained={'secondary'}
              onClick={learnMoreModalAction}
            />
          )}
          <IconButton
            ariaLabel='Check_condition'
            icon='chevronRight'
            color='transparent'
            size='small'
            onClick={() => showDetails(row)}
          />
        </div>
      </div>
    ),
  },
]
